import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

import { Subscription } from 'rxjs';
import { PageLoaderService } from '@Workspace/services';

@Directive({
    selector: '[fullPageLoader]'
})
export class FullPageLoaderDirective implements OnDestroy {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private pageLoaderService: PageLoaderService
    ) {
        this.sub = this.pageLoaderService.isPageLoading.subscribe(
            ({ isLoading, message }: { isLoading: boolean; message?: string }) => {
                if (isLoading) {
                    this.renderer.addClass(
                        this.el.nativeElement,
                        'full-page-loader'
                    );

                    if (message) {
                        this.messageElement = this.renderer.createElement('h3');
                        const text = this.renderer.createText(message);
                        this.renderer.appendChild(this.messageElement, text);
                        this.renderer.appendChild(this.el.nativeElement, this.messageElement);
                        this.renderer.addClass(this.messageElement, 'page-loader-message');
                    }

                } else {
                    this.renderer.removeClass(
                        this.el.nativeElement,
                        'full-page-loader'
                    );

                    if (this.messageElement) {
                        this.renderer.removeChild(this.el.nativeElement, this.messageElement);
                        this.messageElement = null;
                    }
                }
            }
        );
    }

    private sub: Subscription;
    private messageElement: HTMLElement | null = null;

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}